import { render, staticRenderFns } from "./LoanManagementTable.vue?vue&type=template&id=6c0a9b22&scoped=true&"
import script from "./LoanManagementTable.vue?vue&type=script&lang=js&"
export * from "./LoanManagementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a9b22",
  null
  
)

export default component.exports